import React from 'react';
import {
    Paper,
    Grid,
    Typography,
    Divider,
    // eslint-disable-next-line no-unused-vars
} from '@mui/material';
import { format, differenceInCalendarMonths } from 'date-fns';
import ArrowRightAlt from '@mui/icons-material/ArrowRightAlt';
import Month from './Month';
import DefinedRanges from './DefinedRanges';
import {
    // eslint-disable-next-line no-unused-vars
    DateRange,
    // eslint-disable-next-line no-unused-vars
    DefinedRange,
    // eslint-disable-next-line no-unused-vars
    Setter,
    // eslint-disable-next-line no-unused-vars
    NavigationAction,
} from '../types';
import { MARKERS } from './DateRangePicker';

interface MenuProps {
    dateRange: DateRange;
    ranges: DefinedRange[];
    minDate: Date;
    maxDate: Date;
    firstMonth: Date;
    secondMonth: Date;
    setFirstMonth: Setter<Date>;
    setSecondMonth: Setter<Date>;
    setDateRange: Setter<DateRange>;
    helpers: {
        inHoverRange: (day: Date) => boolean;
    };
    handlers: {
        onDayClick: (day: Date) => void;
        onDayHover: (day: Date) => void;
        onMonthNavigate: (marker: symbol, action: NavigationAction) => void;
    };
}

const Menu: React.FunctionComponent<MenuProps> = (props: MenuProps) => {
    const {
        ranges,
        dateRange,
        minDate,
        maxDate,
        firstMonth,
        setFirstMonth,
        secondMonth,
        setSecondMonth,
        setDateRange,
        helpers,
        handlers,
    } = props;

    const { startDate, endDate } = dateRange;
    const canNavigateCloser =
        differenceInCalendarMonths(secondMonth, firstMonth) >= 2;
    const commonProps = {
        dateRange,
        minDate,
        maxDate,
        helpers,
        handlers,
    };
    return (
        <Paper elevation={5} square>
            <Grid
                container
                direction="row"
                wrap="nowrap"
                className="header-menu"
            >
                <Grid>
                    <Grid
                        container
                        className="header-daterangepicker"
                        alignItems="center"
                    >
                        <Grid item className="headerItem-daterangepicker">
                            <Typography
                                variant="subtitle1"
                                className="start-date-rangepicker"
                            >
                                {startDate
                                    ? format(startDate, 'MMMM dd, yyyy')
                                    : 'Start Date'}
                            </Typography>
                        </Grid>
                        <Grid item className="headerItem-daterangepicker">
                            <ArrowRightAlt color="action" />
                        </Grid>
                        <Grid item className="headerItem-daterangepicker">
                            <Typography
                                variant="subtitle1"
                                className="end-date-rangepicker"
                            >
                                {endDate
                                    ? format(endDate, 'MMMM dd, yyyy')
                                    : 'End Date'}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Divider />
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        wrap="nowrap"
                    >
                        <Month
                            {...commonProps}
                            value={firstMonth}
                            setValue={setFirstMonth}
                            navState={[true, canNavigateCloser]}
                            marker={MARKERS.FIRST_MONTH}
                        />
                        <div className="divider-daterangepicker" />
                        <Month
                            {...commonProps}
                            value={secondMonth}
                            setValue={setSecondMonth}
                            navState={[canNavigateCloser, true]}
                            marker={MARKERS.SECOND_MONTH}
                        />
                    </Grid>
                </Grid>
                <div className="divider-daterangepicker" />
                <Grid>
                    <DefinedRanges
                        selectedRange={dateRange}
                        ranges={ranges}
                        setRange={setDateRange}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
};

export default Menu;
